<script setup>
import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="bg-white p-12 rounded-lg shadow-lg">
        <!-- Title -->
        <h2 class="text-4xl md:text-5xl">{{ $t('Onze Missie: Duurzame Oplossingen Bieden') }}</h2>

        <!-- Description -->

        <!-- Service Cards -->
        <div class="mt-8 grid md:grid-cols-3 gap-6">
          <!-- Card 1 -->
          <div class="bg-[#E7F3EB] p-6 rounded-lg shadow-md">
            <h3 class="text-xl font-semibold">{{ $t('Flexibele en Duurzame Zorgoplossingen') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('Zorgblik biedt op maat gemaakte, flexibele en duurzame oplossingen. Naast de inzet van uitzendkrachten richten we ons op het analyseren en oplossen van organisatorische uitdagingen binnen zorginstellingen, met als doel een gewenste en duurzame verandering te realiseren.') }}</p>
          </div>

          <!-- Card 2 -->
          <div class="bg-[#E7F3EB] p-6 rounded-lg shadow-md">
            <h3 class="text-xl font-semibold">{{ $t('Hooggekwalificeerde Zorgprofessionals') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('Wij werken met deskundige zorgprofessionals die als uitzendkracht of zzp’er individueel of in teamverband bijdragen aan betere zorg, een gezonde werkomgeving en een veilige leefomgeving voor cliënten.') }}</p>
          </div>

          <!-- Card 3 -->
          <div class="bg-[#E7F3EB] p-6 rounded-lg shadow-md">
            <h3 class="text-xl font-semibold">{{ $t('Zorgblik Academy') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('Via de Zorgblik Academy bieden we (bij)scholing, training en coaching. Samen met onderwijs- en zorginstellingen creëren we nieuw zorgtalent en ondersteunen we professionals in hun groei door kennisdeling, supervisie en intervisie.') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  